import { motion } from "framer-motion";
import { IMAGES } from "../lib/config";
import { Quote } from "lucide-react";

const MESSAGES = [
  {
    text: "Dios no te llamó a ser ordinario. Te llamó a vivir una vida extraordinaria.",
    author: "Mensaje del Pastor",
  },
  {
    text: "Tu rescate ya está pagado. Solo necesitas decir SÍ.",
    author: "Reflexión",
  },
  {
    text: "El campamento que cambió mi vida. No fui el mismo después de esa noche worship.",
    author: "— Joven 2024",
  },
];

export default function WorshipSection() {
  return (
    <section className="relative bg-black overflow-hidden py-24 lg:py-32 px-6 lg:px-12">
      {/* Background image */}
      <div className="absolute inset-0 opacity-40">
        <img src={IMAGES.worship} alt="" className="w-full h-full object-cover" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black via-black/80 to-black" />
      <div className="absolute inset-0 grain" />

      <div className="relative max-w-6xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <span className="inline-block px-4 py-2 border border-yellow-400/50 text-yellow-400 text-xs uppercase tracking-[0.4em] font-bold mb-6">
            Noche de Adoración
          </span>
          <h2 className="font-heading uppercase text-white text-5xl sm:text-7xl lg:text-9xl leading-[0.9] tracking-tighter">
            Una noche que<br />
            <span className="text-gradient-gold">cambiará todo</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 mt-16">
          {MESSAGES.map((m, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              className="relative p-8 border border-white/10 bg-white/5 backdrop-blur-sm card-hover"
              data-testid={`worship-message-${i}`}
            >
              <Quote className="w-8 h-8 text-yellow-400 mb-4" />
              <p className="text-white text-lg lg:text-xl leading-relaxed font-light italic">"{m.text}"</p>
              <div className="mt-6 pt-4 border-t border-white/10 text-yellow-400/80 text-xs uppercase tracking-widest">
                {m.author}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
